import { Toastr } from '@gef-ui/components/organisms/Toastr';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { removeToast } from '../../actions';
import { getToastr } from '../../selectors';
const ReduxToastr = ({ toasts, removeToast })=>/*#__PURE__*/ React.createElement(Toastr, {
        onClose: removeToast,
        toasts: toasts
    });
ReduxToastr.propTypes = {
    removeToast: PropTypes.func,
    toasts: PropTypes.array
};
const _mapStateToProps = (state)=>getToastr(state);
const _mapDispatchToProps = (dispatch)=>({
        removeToast: bindActionCreators(removeToast, dispatch)
    });
export default connect(_mapStateToProps, _mapDispatchToProps)(ReduxToastr);
